/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseBookingCudto } from '../../models/recourse-booking-cudto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreateNewRecourseBookingTestData$Params {
  startApproval: boolean;
  body: RecourseBookingCudto;
}

export function createNewRecourseBookingTestData(
  http: HttpClient,
  rootUrl: string,
  params: CreateNewRecourseBookingTestData$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, createNewRecourseBookingTestData.PATH, 'put');
  if (params) {
    rb.path('startApproval', params.startApproval, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

createNewRecourseBookingTestData.PATH =
  '/service/v1/automatedUiTesting/booking/createNewRecourseBooking/{startApproval}';
